import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const CompletionStep = ({ userData, onComplete }) => {
  const recommendations = [
  {
    id: 1,
    type: 'event',
    title: 'Boğaz SUP Turu',
    location: 'İstanbul',
    date: '25 Aralık 2025',
    image: "https://images.unsplash.com/photo-1726167400703-240b34c4bc17",
    imageAlt: 'Group of people paddleboarding on calm blue water with Istanbul Bosphorus bridge in background during golden hour sunset',
    icon: 'Calendar'
  },
  {
    id: 2,
    type: 'spot',
    title: 'Alaçatı Surf Beach',
    location: 'İzmir',
    rating: 4.8,
    image: "https://images.unsplash.com/photo-1662067077747-1b5561c58597",
    imageAlt: 'Scenic coastal beach view with turquoise water, sandy shore, and windsurfers in distance under clear blue sky',
    icon: 'MapPin'
  },
  {
    id: 3,
    type: 'product',
    title: 'Red Paddle Co Explorer',
    price: '₺18.500',
    image: "https://images.unsplash.com/photo-1514944137161-db35a1a43935",
    imageAlt: 'Professional red inflatable stand up paddleboard with black paddle lying on wooden dock beside calm lake water',
    icon: 'ShoppingBag'
  }];


  return (
    <div className="w-full max-w-6xl mx-auto px-4 md:px-6 lg:px-8 py-6 md:py-8 lg:py-10">
      <div className="text-center mb-8 md:mb-10 lg:mb-12">
        <div className="w-20 h-20 md:w-24 md:h-24 bg-[var(--color-success)] rounded-full flex items-center justify-center mx-auto mb-6 md:mb-8">
          <Icon name="Check" size={48} className="text-[var(--color-success-foreground)]" />
        </div>
        <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[var(--color-foreground)] mb-3 md:mb-4">
          Hoş Geldiniz, {userData?.name || 'Paddler'}!
        </h2>
        <p className="text-sm md:text-base lg:text-lg text-[var(--color-muted-foreground)] max-w-2xl mx-auto">
          Profiliniz başarıyla oluşturuldu. Size özel önerilerimize göz atın
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8 mb-8 md:mb-10 lg:mb-12">
        <div className="bg-[var(--color-card)] rounded-xl md:rounded-2xl p-6 md:p-7 lg:p-8 border border-[var(--color-border)] text-center">
          <div className="w-14 h-14 md:w-16 md:h-16 bg-[var(--color-primary)] rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="Users" size={28} className="text-[var(--color-primary-foreground)]" />
          </div>
          <h3 className="text-xl md:text-2xl font-bold text-[var(--color-foreground)] mb-2">
            2.847
          </h3>
          <p className="text-sm md:text-base text-[var(--color-muted-foreground)]">
            Aktif Paddler
          </p>
        </div>

        <div className="bg-[var(--color-card)] rounded-xl md:rounded-2xl p-6 md:p-7 lg:p-8 border border-[var(--color-border)] text-center">
          <div className="w-14 h-14 md:w-16 md:h-16 bg-[var(--color-secondary)] rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="Calendar" size={28} className="text-[var(--color-secondary-foreground)]" />
          </div>
          <h3 className="text-xl md:text-2xl font-bold text-[var(--color-foreground)] mb-2">
            156
          </h3>
          <p className="text-sm md:text-base text-[var(--color-muted-foreground)]">
            Yaklaşan Etkinlik
          </p>
        </div>

        <div className="bg-[var(--color-card)] rounded-xl md:rounded-2xl p-6 md:p-7 lg:p-8 border border-[var(--color-border)] text-center">
          <div className="w-14 h-14 md:w-16 md:h-16 bg-[var(--color-accent)] rounded-full flex items-center justify-center mx-auto mb-4">
            <Icon name="MapPin" size={28} className="text-[var(--color-accent-foreground)]" />
          </div>
          <h3 className="text-xl md:text-2xl font-bold text-[var(--color-foreground)] mb-2">
            89
          </h3>
          <p className="text-sm md:text-base text-[var(--color-muted-foreground)]">
            Keşfedilecek Spot
          </p>
        </div>
      </div>
      <div className="mb-8 md:mb-10 lg:mb-12">
        <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-[var(--color-foreground)] mb-6 md:mb-8">
          Size Özel Öneriler
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6 lg:gap-8">
          {recommendations?.map((item) =>
          <div
            key={item?.id}
            className="bg-[var(--color-card)] rounded-xl md:rounded-2xl overflow-hidden border border-[var(--color-border)] hover:shadow-organic-lg transition-smooth">

              <div className="relative h-48 md:h-56 lg:h-64 overflow-hidden">
                <Image
                src={item?.image}
                alt={item?.imageAlt}
                className="w-full h-full object-cover" />

                <div className="absolute top-4 right-4 w-10 h-10 bg-[var(--color-card)] rounded-full flex items-center justify-center">
                  <Icon name={item?.icon} size={20} className="text-[var(--color-primary)]" />
                </div>
              </div>
              <div className="p-5 md:p-6">
                <h4 className="text-base md:text-lg font-semibold text-[var(--color-foreground)] mb-2 line-clamp-2">
                  {item?.title}
                </h4>
                <div className="flex items-center gap-2 text-sm md:text-base text-[var(--color-muted-foreground)]">
                  <Icon name="MapPin" size={16} />
                  <span>{item?.location}</span>
                </div>
                {item?.date &&
              <div className="flex items-center gap-2 text-sm md:text-base text-[var(--color-muted-foreground)] mt-2">
                    <Icon name="Calendar" size={16} />
                    <span>{item?.date}</span>
                  </div>
              }
                {item?.rating &&
              <div className="flex items-center gap-2 text-sm md:text-base text-[var(--color-muted-foreground)] mt-2">
                    <Icon name="Star" size={16} className="text-[var(--color-accent)]" />
                    <span>{item?.rating}</span>
                  </div>
              }
                {item?.price &&
              <p className="text-lg md:text-xl font-bold text-[var(--color-primary)] mt-3">
                    {item?.price}
                  </p>
              }
              </div>
            </div>
          )}
        </div>
      </div>
      <div className="bg-[var(--color-muted)] rounded-xl md:rounded-2xl p-6 md:p-8 lg:p-10 text-center">
        <Icon name="Sparkles" size={48} className="text-[var(--color-primary)] mx-auto mb-4 md:mb-6" />
        <h3 className="text-xl md:text-2xl lg:text-3xl font-bold text-[var(--color-foreground)] mb-3 md:mb-4">
          Hazırsınız!
        </h3>
        <p className="text-sm md:text-base lg:text-lg text-[var(--color-muted-foreground)] max-w-2xl mx-auto mb-6 md:mb-8">
          Türkiye'nin en büyük SUP topluluğuna katıldınız. Şimdi etkinlikleri keşfetmeye başlayabilirsiniz
        </p>
        <Button
          variant="default"
          size="lg"
          onClick={onComplete}
          iconName="ArrowRight"
          iconPosition="right">

          Platformu Keşfet
        </Button>
      </div>
    </div>);

};

export default CompletionStep;